(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name crewing.controller:CrewingFilterModalControllerCtrl
     *
     * @description
     *
     */
    angular
        .module('crewing')
        .controller('CrewingFilterModalCtrl', CrewingFilterModalCtrl);

    function CrewingFilterModalCtrl($uibModalInstance, modalParams, CommonMasterData, MessageService, CrewingHelper) {
        var vm = this;

        vm.model = {
            airports: [],
            events: [],
            leaves: [],
            flights: [],
            selectedValues: {
                flights: [],
                airports: [],
                events: [],
                leaves: [],
                day: modalParams.day.date
            },
            isAllLeavesSelected: false,
            isAllEventsSelected: false
        };

        (function () {
            getFlights();
            getAirports();
            getEventsAndLeaves();
            populateLastFilter('flight');
        })();

        vm.onClose = function () {
            $uibModalInstance.close();
        };

        vm.onFilterClick = function () {
            if (vm.model.selectedValues.flights.length ||
                vm.model.selectedValues.airports.length ||
                vm.model.selectedValues.events.length ||
                vm.model.selectedValues.leaves.length) {
                $uibModalInstance.close(vm.model.selectedValues);
            } else {
                $uibModalInstance.close(vm.model.selectedValues);
            }
        };

        function populateLastFilter(type) {
            if (!!modalParams.lastFilter && (modalParams.day.date == modalParams.lastFilter.date)) {
                switch (type) {
                    case 'event':
                    {
                        if (modalParams.lastFilter.allEvents) {
                            vm.model.isAllEventsSelected = true;
                        } else if (modalParams.lastFilter.events.length > 0) {
                            var tmp;
                            angular.forEach(modalParams.lastFilter.events, function (d) {
                                tmp = _.find(vm.model.events, {eventCode: d})
                                if (!!tmp) {
                                    vm.model.selectedValues.events.push(tmp);
                                }
                            });
                        }
                        break;
                    }

                    case 'leave':
                    {
                        if (modalParams.lastFilter.allLeaves) {
                            vm.model.isAllLeavesSelected = true;
                        } else if (modalParams.lastFilter.leaves.length > 0) {
                            var tmp;
                            angular.forEach(modalParams.lastFilter.leaves, function (d) {
                                tmp = _.find(vm.model.leaves, {eventCode: d})
                                if (!!tmp) {
                                    vm.model.selectedValues.leaves.push(tmp);
                                }
                            });
                        }
                        break;
                    }

                    case 'destination' :
                    {
                        if (modalParams.lastFilter.destinations.length > 0) {
                            var tmp;
                            angular.forEach(modalParams.lastFilter.destinations, function (d) {
                                tmp = _.find(vm.model.airports, {airPortCode: d})
                                if (!!tmp) {
                                    vm.model.selectedValues.airports.push(tmp);
                                }
                            });
                        }
                        break;
                    }
                    case 'flight':
                    {
                        if (modalParams.lastFilter.flightNumbers.length > 0) {
                            vm.model.selectedValues.flights = modalParams.lastFilter.flightNumbers;
                        }
                        break;
                    }
                }
            }
        }

        function getAirports() {
            CommonMasterData.getAirportList(
                function (airports) {
                    vm.model.airports = airports;
                    populateLastFilter('destination');
                }, function (error) {
                    MessageService.error(error);
                })
        }

      function getFlights() {
        CommonMasterData.getFlights(vm.model.selectedValues.day,
          function (flights) {
            vm.model.flights = flights;
            populateLastFilter('flight');
          }, function (error) {
            MessageService.error(error);
          })
      }

        function getEventsAndLeaves() {
            CrewingHelper.getEvents(
                function (eventsAndLeave) {
                    vm.model.events = eventsAndLeave.DUTY;
                    populateLastFilter('event');
                    vm.model.leaves = eventsAndLeave.LEAVE;
                    populateLastFilter('leave');
                }, function (error) {
                    MessageService.error(error);
                },
              null);
        }
    }
}());
